import { Model } from '@vuex-orm/core';

/**
 * ORM Model
 * @see {@link https://vuex-orm.github.io/vuex-orm/guide/components/models.html}
 */
export class Me extends Model {
  static entity = 'me'

  static primaryKey = 'volunteer_id'

  static fields () {
    return {
      volunteer_id: this.attr(null),
      total_calls: this.attr(null)
    };
  }

  static async getForLoggedInUser () {
    let me = Me.query().first();
    if (!me) {
      me = await Me.$fetch();
    }
    return me;
  }

  /**
   * Axios default overrides
   * @see {@link https://github.com/vuex-orm/plugin-axios/blob/master/README.md}
   */
  static methodConf = {
    http: {
      url: 'regicall/me'
    },
    methods: {
    }
  }
}
